"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = require("react");
var _reactHotkeysHook = require("react-hotkeys-hook");
// Should not scroll after the first match is scrolled into view
var shouldScrollGlobal = true;
var useGoToHighlighted = function useGoToHighlighted(isHighlighted, searchValue) {
  var ref = (0, _react.useRef)();

  // shouldScrollGlobal is reset for every search term
  (0, _react.useEffect)(function () {
    shouldScrollGlobal = true;
  }, [searchValue]);
  (0, _reactHotkeysHook.useHotkeys)("Enter", function () {
    if (isHighlighted && ref !== null && ref !== void 0 && ref.current && shouldScrollGlobal) {
      shouldScrollGlobal = false;
      ref.current.scrollIntoView({
        behavior: "smooth"
      });
    }
  }, {
    enableOnTags: ["INPUT"]
  }, [isHighlighted]);
  return ref;
};
var _default = useGoToHighlighted;
exports["default"] = _default;